import { CharField } from "@inmagik/magik-ui"
import { getIn, useFormikContext } from "formik"
import { Col } from "react-bootstrap"
import type { User } from "../../types"

export default function UtenteForm({ col = 8 }: { col?: number }) {
  const { setFieldValue, values, errors, submitCount } = useFormikContext<User>()

  return (
    <Col xs={col} className="d-flex flex-column align-items-stretch gap-4">
      <CharField
        label="Email"
        layout="horizontal"
        value={values.email}
        onChange={(value) => {
          setFieldValue("email", value)
        }}
        isValid={submitCount > 0 ? !getIn(errors, "email") : undefined}
        errorMessage={getIn(errors, "email")}
        required
      />
      <CharField
        label="Nome e cognome"
        layout="horizontal"
        value={values.full_name}
        onChange={(value) => {
          setFieldValue("full_name", value)
        }}
        isValid={submitCount > 0 ? !getIn(errors, "full_name") : undefined}
        errorMessage={getIn(errors, "full_name")}
        required
      />
    </Col>
  )
}
